import { SATYA, TEAM } from "../../data/content";
import { Reveal, RevealText } from "../Reveal";

export default function About() {
  return (
    <section id="about" className="relative bg-navy-900 py-24 sm:py-32 md:py-40">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-12">
        <div className="grid gap-16 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24">
          {/* Sticky heading */}
          <div className="lg:sticky lg:top-32 lg:self-start">
            <Reveal>
              <p className="mb-6 text-[11px] uppercase tracking-[0.4em] text-gold">The Studio</p>
            </Reveal>
            <h2 className="font-heading text-4xl font-light leading-tight text-offwhite sm:text-5xl">
              <RevealText text="Not a contractor." />
              <br />
              <RevealText text="A build partner with" delay={0.1} />
              <span className="italic text-gold"> <RevealText text="architectural rigour." delay={0.2} /></span>
            </h2>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-md text-base font-light leading-relaxed text-offwhite/70">
                We transform spaces with expertise and precision — bringing design intelligence,
                transparent costing and reliable execution to every project, from office
                to home.
              </p>
            </Reveal>
          </div>

          {/* SATYA */}
          <div>
            <Reveal>
              <p className="mb-8 text-[11px] uppercase tracking-[0.4em] text-offwhite/50">
                Our philosophy — <span className="text-gold">SATYA</span> · सत्य · Truth
              </p>
            </Reveal>
            <div className="divide-y divide-gold/10 border-y border-gold/10">
              {SATYA.map((s, i) => (
                <Reveal key={i} delay={i * 0.05}>
                  <div data-cursor="hover" className="group flex items-baseline gap-6 py-6 transition-colors duration-500 hover:bg-navy-800/40 sm:gap-10">
                    <span className="font-heading text-5xl font-light text-gold/40 transition-colors duration-500 group-hover:text-gold sm:text-6xl">
                      {s.letter}
                    </span>
                    <div>
                      <h3 className="font-heading text-2xl text-offwhite sm:text-3xl">{s.word}</h3>
                      <p className="mt-1 max-w-md text-sm font-light text-offwhite/60">{s.note}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            {/* Team */}
            <div className="mt-16">
              <Reveal>
                <p className="mb-6 text-[11px] uppercase tracking-[0.4em] text-offwhite/50">Founding members</p>
              </Reveal>
              <div className="grid gap-px overflow-hidden rounded-sm border border-gold/10 sm:grid-cols-3">
                {TEAM.map((t, i) => (
                  <Reveal key={i} delay={i * 0.08}>
                    <div data-cursor="hover" className="group h-full bg-navy-800/40 p-6 transition-colors duration-500 hover:bg-navy-800">
                      <p className="font-heading text-xl text-offwhite transition-colors group-hover:text-gold">{t.name}</p>
                      <p className="mt-2 text-xs uppercase tracking-[0.2em] text-offwhite/50">{t.role}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
